import React from 'react';

const TranslationsContext = React.createContext();
const TranslationsProvider = TranslationsContext.Provider;

export default TranslationsContext;
export { TranslationsProvider };
